import { render } from "./ListDocuments.vue?vue&type=template&id=3c37e212"
import script from "./ListDocuments.vue?vue&type=script&lang=js"
export * from "./ListDocuments.vue?vue&type=script&lang=js"

import "./ListDocuments.vue?vue&type=style&index=0&id=3c37e212&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__